<template>
  <div class="dialog-batch-migrate-wrapper">
    <el-dialog title="批量迁移设备" :visible="visible" @open="onDialogOpen" @close="onDialogClose" >
      <el-form label-position="top" ref="batchMigrateForm" :rules="batchMigrateRules" :model="batchMigrateForm">

        <el-form-item label="入件商户" prop="userid">
          <el-select v-model="batchMigrateForm.userid" filterable placeholder="请选择商户">
            <el-option
              v-for="user in userList"
              :key="user.userid"
              :label="user.username"
              :value="user.userid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备类型" prop="type">
          <el-select v-model="batchMigrateForm.type" placeholder="请选择设备类型">
            <el-option label="扭蛋机" value="gpm"></el-option>
            <el-option label="自动贩卖机" value="vm"></el-option>
            <el-option label="口红机" value="lpk"></el-option>
            <el-option label="脉冲" value="mc"></el-option>
            <el-option label="福袋机" value="fdj"></el-option>
            <el-option label="格子机" value="gzj"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="设备名" prop="title">
          <el-input v-model="batchMigrateForm.title"
            @keyup.enter.native="onBatchMigrateSubmit"></el-input>
        </el-form-item>

        <el-form-item style="display: flex; justify-content: center;">
          <el-button type="danger" @click="onBatchMigrateSubmit">确定</el-button>
          <el-button @click="onBatchMigrateCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Loading } from 'element-ui'

export default {
  name: 'DialogBatchMigrate',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    selectedDevs: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      batchMigrateForm: {
        userid: 960029,
        title: '扭蛋机',
        type: 'gpm'
      },
      batchMigrateRules: {
        userid: [
          { required: true, message: '请选择设备所属用户', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择设备类型', trigger: 'change' }
        ],
        title: [
          { required: true, message: '请输入设备名称', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState('user', [
      'userList'
    ]),
    ...mapState('table', [
      'filters'
    ])
  },
  methods: {
    ...mapActions('user', [
      'getUsers'
    ]),
    ...mapActions('device', [
      'batchMigrate'
    ]),

    async onDialogOpen () {
      // Load all user
      try {
        await this.getUsers({
          page: 1,
          pageSize: 9999
        })
      } catch (err) {
        console.log(err)
      }
    },
    async onDialogClose () {
      this.$emit('update:visible', false)

      // Restore user list, restore filter condition
      try {
        await this.getUsers({
          page: 1,
          pageSize: 9999,
          filters: {
            agentid: this.filters.agentid || ''
          }
        })
      } catch (err) {
        console.log(err)
      }
    },

    async onBatchMigrateSubmit () {
      this.$refs['batchMigrateForm'].validate(async valid => {
        try {
          const fullLoading = Loading.service({
            fullscreen: true
          })

          const sns = []
          this.selectedDevs.forEach(row => {
            sns.push(row.sn)
          })
          await this.batchMigrate({
            sns: sns,
            userid: this.batchMigrateForm.userid,
            title: this.batchMigrateForm.title,
            type: this.batchMigrateForm.type
          })

          this.$nextTick(() => {
            fullLoading.close()
          })
          this.$refs['batchMigrateForm'].resetFields()

          this.$message({
            type: 'success',
            message: '批量迁移成功'
          })
          this.$emit('update:visible', false)
          this.$emit('data-change')
        } catch (err) {
          console.log(err)
          this.$message({
            type: 'error',
            message: '批量迁移失败'
          })
        }
      })
    },
    onBatchMigrateCancel () {
      this.$emit('update:visible', false)
      this.$refs['batchMigrateForm'].resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dev/DialogBatchMigrate.vue